export function razonSocialFromPadron(padron) {
  const rs = (padron.razonSocial || '').trim()
  if (rs) return rs
  return ((padron.apellido || '') + ' ' + (padron.nombre || '')).trim()
}

export function applyPadronToRegistro(registro, padron) {
  const direccion = padron.domicilio?.find((x) => x.tipoDomicilio === 'FISCAL')
  if (padron.nombre) registro.nombre = padron.nombre
  if (padron.apellido) registro.apellido = padron.apellido
  registro.razonSocial = razonSocialFromPadron(padron)
  if (direccion?.calle) {
    registro.provincia = direccion.idProvincia != null ? direccion.idProvincia : registro.provincia
    registro.direccion = ((direccion.calle || '') + ' ' + (direccion.numero || '')).trim()
  }
  return registro.razonSocial
}
